import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcList(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 6c0 .414.336.75.75.75h12.5a.75.75 0 0 0 0-1.5H8.25A.75.75 0 0 0 7.5 6M3 6c0 .414.336.75.75.75h1a.75.75 0 0 0 0-1.5h-1A.75.75 0 0 0 3 6m4.5 6c0 .414.336.75.75.75h12.5a.75.75 0 0 0 0-1.5H8.25a.75.75 0 0 0-.75.75M3 12c0 .414.336.75.75.75h1a.75.75 0 0 0 0-1.5h-1A.75.75 0 0 0 3 12m4.5 6c0 .414.336.75.75.75h12.5a.75.75 0 0 0 0-1.5H8.25a.75.75 0 0 0-.75.75M3 18c0 .414.336.75.75.75h1a.75.75 0 0 0 0-1.5h-1A.75.75 0 0 0 3 18",
    clipRule: "evenodd"
  }));
}
var IcList = createNolIcon(/*#__PURE__*/forwardRef(SvgIcList));

export { IcList as I };
